import webViewBridge from './WebViewBridge';

const WebViewBridgeProvider = webViewBridge().WebViewBridgeProvider;
const useWebViewBridge = webViewBridge().useWebViewBridge;
const WebViewBridgeConsumer = webViewBridge().WebViewBridgeConsumer;

export { WebViewBridgeProvider, useWebViewBridge, WebViewBridgeConsumer };
